import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'spw-card-subtag-item',
  styleUrl: 'spw-card-subtag-item.scss',
  shadow: true,
})
export class SpwCardSubtagItem {
  /** Lien qui mène vers la catégorie du sous-tag */
  @Prop() link?: string;

  handleClick() {
    if (this.link) {
      window.location.href = this.link;
    }
  }

  private get elementClass(): { [className: string]: boolean } {
    return {
      'spw-card-subtag-item': true,
      'spw-card-subtag-item--has-link': !!this.link,
    };
  }

  render() {
    return (
      <Host>
        <span class={this.elementClass} onClick={() => this.handleClick()}>
          <slot></slot>
        </span>
      </Host>
    );
  }
}
